import { render } from "./Tooltip.vue?vue&type=template&id=0ff5f1f4"
import script from "./Tooltip.vue?vue&type=script&lang=ts"
export * from "./Tooltip.vue?vue&type=script&lang=ts"

import "./Tooltip.vue?vue&type=style&index=0&id=0ff5f1f4&lang=scss"
script.render = render

export default script